module.exports = __webpack_public_path__ + "img/science.2294964b.png";